<template>
    <div>
        <v-layout row wrap class="ma-8">
            <v-flex xs12>
                <v-card class='grey lighten-4'>
                    <v-layout row wrap>

                        <v-flex xs12>
                            <h2 class="font-weight-bold text-center">Shift Lead Performance Evaluation</h2>
                            <v-divider class="ml-12 mr-12 mt-5"></v-divider>

                        </v-flex>


                        <v-flex xs6 class="pa-5">
                            <v-select 
                                label="Select an Employee to Review"
                                v-model="employeeName"
                                :items="users"
                                item-text="Name"
                                item-value="_id"
                            ></v-select>
                        </v-flex>

                        <v-flex xs6 class="pa-5">
                            <v-text-field 
                                label="Date of Review"
                                v-model="employeeDate"
                            ></v-text-field>
                        </v-flex>

                        <v-flex xs3>
                            
                        </v-flex>

                        <v-flex xs3>
                           <h3>Score</h3>
                        </v-flex>

                        <v-flex xs6>
                            <h3>Task Description</h3>
                        </v-flex>

                        <v-flex xs12 class="pa-4">
                            <v-card>
                                <v-card-subtitle class="pl-4">Individuals</v-card-subtitle>

                                <v-divider class="ma-5"></v-divider>

                                <v-layout row wrap>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="health1"
                                            @input="updateScore()"
                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{health1}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Knows the health of the individuals i.e. medication, health, 
                                            nutritional needs, likes, dislikes, needed supports.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="health2"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{health2}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            The appearance and hygiene of the individuals is
                                            maintained throughout the day.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="health3"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{health3}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Monitors and charts seizures and other medical issues and 
                                            reports timely to supervisor with necessary documentation.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="health4"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{health4}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Completes incident/accident reports completely and timely.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                       <v-rating 
                                            length="5"
                                            v-model="health5"
                                            @input="updateScore()"
                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{health5}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Assists the individuals in a professional manner and 
                                            implements safety trainings.
                                        </p>
                                    </v-flex>


                                </v-layout>
                            </v-card>

                        </v-flex>

                        <v-flex xs12 class="pa-4">
                            <v-card>
                                <v-card-subtitle class="pl-4">Medical</v-card-subtitle>

                                <v-divider class="ma-5"></v-divider>

                                <v-layout row wrap>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="medical1"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{medical1}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Assists with medications accurately and charts accurately.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="medical2"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{medical2}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Knows the medications and side effects for each individual.  
                                            Knows the protocol for missed medications.
                                        </p>
                                    </v-flex>

                                    <!-- <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="staffing3"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{staffing3}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Address staff issues and problem solve in a positive manner. Create ways
                                            to build positive staff morale.
                                        </p>
                                    </v-flex> -->

                                    <!-- <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="staffing4"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{staffing4}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Communicate and work with Human Resources on required paperwork.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="staffing5"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{staffing5}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that staff interact with individuals in an age appropriate 
                                            manner, keeping dignity, respect and confidentiality in all interactions.
                                        </p>
                                    </v-flex> -->


                                </v-layout>
                            </v-card>

                        </v-flex>

                        <v-flex xs12 class="pa-4">
                            <v-card>
                                <v-card-subtitle class="pl-4">Staff Training</v-card-subtitle>

                                <v-divider class="ma-5"></v-divider>

                                <v-layout row wrap>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="training1"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{training1}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Attends all site staff training, and other training as required.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="training2"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{training2}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Maintains employment requirements.
                                        </p>
                                    </v-flex>


                                </v-layout>
                            </v-card>

                        </v-flex>

                        <v-flex xs12 class="pa-4">
                            <v-card>
                                <v-card-subtitle class="pl-4">Dependability</v-card-subtitle>

                                <v-divider class="ma-5"></v-divider>

                                <v-layout row wrap>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="dependability1"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                     <v-flex xs3>
                                        {{dependability1}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Arrives on time for scheduled shifts.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="dependability2"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                     <v-flex xs3>
                                        {{dependability2}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Clocks in and out for each shift and signs each timecard. Obtains 
                                            the manager’s initials when there is not an electronic time punch 
                                            and documents the reason for not punching in or out.
                                        </p>
                                    </v-flex>

                                    <!-- <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="program3"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                     <v-flex xs3>
                                        {{program3}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Follow the chain of command.  Use proper procedures when 
                                            interacting with government entities. Complete tasks on 
                                            time and accurately.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="program4"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                     <v-flex xs3>
                                        {{program4}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that payroll is accurate, complete and submitted on time.  
                                            Ensure that timecards are reviewed, missing electronic punches 
                                            are explained and initialed, and employee and manager signatures 
                                            are present. Mileage sheets complete, and submitted with payroll.  
                                            Two weeks of schedules are submitted with payroll.
                                        </p>
                                    </v-flex> -->


                                </v-layout>
                            </v-card>

                        </v-flex>

                        <v-flex xs12 class="pa-4">
                            <v-card>
                                <v-card-subtitle class="pl-4">Goals</v-card-subtitle>

                                <v-divider class="ma-5"></v-divider>

                                <v-layout row wrap>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="goals1"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{goals1}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Knows the goals of individuals and knows the 
                                            purpose of the goals and charts accurately.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="goals2"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{goals2}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Supports individuals on assigned recreational activities.  
                                            Utilizes community resources to support recreational activities.
                                        </p>
                                    </v-flex>

                                    <!-- <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="transportation3"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{transportation3}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that all individuals books are kept current, filing complete,
                                            annual forms current and ensure that related other paperwork is complete,
                                            current and audit ready.
                                        </p>
                                    </v-flex> -->


                                </v-layout>
                            </v-card>

                        </v-flex>

                        <v-flex xs12 class="pa-4">
                            <v-card>
                                <v-card-subtitle class="pl-4">Behavior Plans</v-card-subtitle>

                                <v-divider class="ma-5"></v-divider>

                                <v-layout row wrap>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="behaviorPlans1"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{behaviorPlans1}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Know the individuals with behavior plans, and know how to 
                                            support them with such plans.
                                        </p>
                                    </v-flex>

                                    <!-- <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                       <v-rating 
                                            length="5"
                                            v-model="medical2"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{medical2}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Communicate emergency room visits to supervisor, parents/guardians, 
                                            service coordinators, and others as needed.  Follow up with required paperwork 
                                            to office and DRC.  Communicate hospital stays, surgeries, etc. to appropriate 
                                            persons.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="medical3"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{medical3}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that staff is competent with medications, medication forms and 
                                            medication procedures.
                                        </p>
                                    </v-flex> -->


                                </v-layout>
                            </v-card>

                        </v-flex>

                        <v-flex xs12 class="pa-4">
                            <v-card>
                                <v-card-subtitle class="pl-4">Communication and Professionalism</v-card-subtitle>

                                <v-divider class="ma-5"></v-divider>

                                <v-layout row wrap>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="communication1"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{communication1}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Uses professional communication skills with individuals, 
                                            management, co-workers, parents, guardians, service coordinators, 
                                            consultants and people in the community.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="communication2"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{communication2}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Maintains confidentiality in all areas of the job.  
                                            Does not discuss personal issues with individuals.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="communication3"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{communication3}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Respects the privacy of individuals and receives permission 
                                            before entering their home or bedroom.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="communication4"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{communication4}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Works as a team member in a professional manner.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="communication5"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{communication5}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Independently uses problem-solving skills.  Initiates tasks, 
                                            uses pagers when necessary, makes good use of time and completes 
                                            job duties.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="communication6"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{communication6}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Follows the chain of command as outlined in the Employee Handbook.
                                        </p>
                                    </v-flex>


                                </v-layout>
                            </v-card>

                        </v-flex>

                        <v-flex xs12 class="pa-4">
                            <v-card>
                                <v-card-subtitle class="pl-4">Housekeeping and Maintenance</v-card-subtitle>

                                <v-divider class="ma-5"></v-divider>

                                <v-layout row wrap>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="housekeeping1"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{housekeeping1}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Notifies supervisor of equipment in need of repair and site maintenance needs.
                                        </p>
                                    </v-flex>

                                    <!-- <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="finances2"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{finances2}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Effectively follow SSA/SSI/Medicaid guidelines and policies.  
                                            Never allow accounts to exceed $2000.00 or allow accounts to have 
                                            a negative balance. Maintain all finances audit compliant as per DRC 
                                            guidelines.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="finances3"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{finances3}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure all bills are paid on time, bills are split evenly among roommates,
                                            receipts are kept, initialed by two staff persons.  Checks are signed by 
                                            individual and  staff person.  Grocery shopping is done regularly, checks 
                                            made payable to the store and cash back never received.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="finances4"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{finances4}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that all money is accounted for, that individuals and 
                                            staff don not loan or borrow money or anything else.  Ensure 
                                            that individuals do not write checks to employees.
                                        </p>
                                    </v-flex> -->

                                </v-layout>
                            </v-card>

                        </v-flex>

                        <v-flex xs12 class="pa-4">
                            <v-card>
                                <v-card-subtitle class="pl-4">Tasks</v-card-subtitle>

                                <v-divider class="ma-5"></v-divider>

                                <v-layout row wrap>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="tasks1"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{tasks1}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure the cleanliness inside and out of the individuals’ home.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="tasks2"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{tasks2}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Supports the individuals’ to prepare nutritious balanced meals.
                                        </p>
                                    </v-flex>

                                    <!-- <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="finances3"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{finances3}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure all bills are paid on time, bills are split evenly among roommates,
                                            receipts are kept, initialed by two staff persons.  Checks are signed by 
                                            individual and  staff person.  Grocery shopping is done regularly, checks 
                                            made payable to the store and cash back never received.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="finances4"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{finances4}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that all money is accounted for, that individuals and 
                                            staff don not loan or borrow money or anything else.  Ensure 
                                            that individuals do not write checks to employees.
                                        </p>
                                    </v-flex> -->

                                </v-layout>
                            </v-card>

                        </v-flex>

                        <v-flex xs12 class="pa-4">
                            <v-card>
                                <v-card-subtitle class="pl-4">Personal Development</v-card-subtitle>

                                <v-divider class="ma-5"></v-divider>

                                <v-layout row wrap>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="personal1"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{personal1}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Knows the individuals rights and applies them with daily living.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="personal2"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{personal2}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Knows Policy and Procedures and ensures compliance.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="personal3"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{personal3}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Knows both The Division of Services for People with Disabilities 
                                            and the Department of Human Services’ Codes of Conduct and adheres 
                                            to the guidelines within.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="personal4"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{personal4}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Make good use of time. Prioritize assignments.  
                                            Dress and interacts appropriately. 
                                        </p>
                                    </v-flex>

                                    <!-- <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="personal5"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{personal5}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure management coverage for all shifts.  
                                            Make unexpected drop in visits for all shifts (Day, afternoon, 
                                            night, graveyard and weekends).  Ensure documentation and follow up 
                                            for those visits. 
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="personal6"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{personal6}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that each house and day program have adequate 
                                            staffing to maintain all ratios.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="personal7"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{personal7}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that all staff are trained according to RHS 
                                            Policies and Procedures.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="personal8"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{personal8}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that all state required investigations are completed 
                                            within the timeframe specified by the state.
                                        </p>
                                    </v-flex>

                                    <v-divider></v-divider>
                                    
                                    <v-flex xs3 class="pl-4">
                                        <v-rating 
                                            length="5"
                                            v-model="personal9"
                                            @input="updateScore()"

                                        ></v-rating>
                                    </v-flex>

                                    <v-flex xs3>
                                        {{personal9}}/5
                                    </v-flex>

                                    <v-flex xs6>
                                        <p>
                                            Ensure that all Incident Reports are completed as required by 
                                            the state and submitted as specified by the state.
                                        </p>
                                    </v-flex> -->


                                </v-layout>
                            </v-card>

                        </v-flex>

                        <v-flex xs12>
                            <v-card class="ma-3">
                                <v-card-title class="font-weight-bold ml-3">Overall Evaluation</v-card-title>
                                <v-layout row wrap>

                                    <v-flex xs12 class="pl-8">
                                        Evaluation Score: {{parseFloat(scoreTotal).toFixed(2)}}
                                    </v-flex>

                                    <v-flex xs6 class="pa-6">
                                        <v-textarea 
                                            label="Improvement Opportunities"
                                            v-model="improvement"
                                        ></v-textarea>
                                    </v-flex>

                                    <v-flex xs6 class="pa-6">
                                        <v-textarea 
                                            label="Successes"
                                            v-model="successes"
                                        ></v-textarea>
                                    </v-flex>

                                    <v-flex xs12 class="pa-6">
                                        <v-card-subtitle>This evaluation has been discussed and my questions answered.</v-card-subtitle>
                                    </v-flex>

                                    <v-flex xs6 class="pa-6">
                                        <v-text-field 
                                            label="Staff Name"
                                            v-model="staffName"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 class="pa-6">
                                        <v-text-field 
                                            label="Date"
                                            v-model="staffDate"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 class="pa-6">
                                        <v-text-field 
                                            label="Program Director"
                                            v-model="programDirector"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs6 class="pa-6">
                                        <v-text-field 
                                            label="Date"
                                            v-model="programDate"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs12 class="pa-5">
                                        <v-btn @click="addReview()">Submit Review</v-btn>
                                    </v-flex>

                                </v-layout>
                            </v-card>
                        </v-flex>

                    </v-layout>
                </v-card>
            </v-flex>

            
            
        </v-layout>

    </div>
</template>
<script>
import axios from 'axios'

const url = require("../../client_config/config").url;


export default {
    data: () => ({
        users: [],
        review: "Shift Lead",
        employeeName: "",
        employeeDate: "",
        health1: 0,
        health2: 0,
        health3: 0,
        health4: 0,
        health5: 0,
        training1: 0,
        training2: 0,
        // staffing3: 0,
        // staffing4: 0,
        // staffing5: 0,
        // security1: 0,
        // security2: 0,
        dependability1: 0,
        dependability2: 0,
        // program3: 0,
        // program4: 0,
        // transportation1: 0,
        // transportation2: 0,
        // transportation3: 0,
        medical1: 0,
        medical2: 0,
        // medical3: 0,
        goals1: 0,
        goals2: 0,
        // goals3: 0,
        // goals4: 0,
        // goals5: 0,
        behaviorPlans1: 0,
        // finances2: 0,
        // finances3: 0,
        // finances4: 0,
        communication1: 0,
        communication2: 0,
        communication3: 0,
        communication4: 0,
        communication5: 0,
        communication6: 0,
        housekeeping1: 0,
        tasks1: 0,
        tasks2: 0,
        personal1: 0,
        personal2: 0,
        personal3: 0,
        personal4: 0,
        personal5: 0,
        personal6: 0,
        personal7: 0,
        personal8: 0,
        personal9: 0,
        scoreTotal: 0,
        improvement: "",
        successes: "",
        staffName: "",
        staffDate: "",
        programDirector: "",
        programDate: "",
        staffId: "",
    }),

    created() {
        this.getUsers()
    },

    methods: {
        getUsers() {
            axios.get(`${url}/users`).then( res => {
                this.users = res.data.users
            })
        },
        updateScore () {
            this.scoreTotal = (
                this.health1 
                + this.health2 
                + this.health3 
                + this.health4 
                + this.health5 
                + this.medical1
                + this.medical2
                + this.training1 
                + this.training2 
                + this.dependability1 
                + this.dependability2 
                + this.goals1 
                + this.goals2 
                + this.behaviorPlans1 
                + this.communication1 
                + this.communication2 
                + this.communication3 
                + this.communication4 
                + this.communication5 
                + this.communication6 
                + this.housekeeping1 
                + this.tasks1 
                + this.tasks2 
                + this.personal1 
                + this.personal2 
                + this.personal3 
                + this.personal4
                
                ) / parseInt(27)

        },

        addReview: function() {
        var req_body = {
            Review: this.review,
            EmployeeName: this.employeeName,
            EmployeeDate: this.employeeDate,
            Health1: this.health1,
            Health2: this.health2,
            Health3: this.health3,
            Health4: this.health4,
            Health5: this.health5,
            Training1: this.training1,
            Training2: this.training2,
            // Staffing3: this.staffing3,
            // Staffing4: this.staffing4,
            // Staffing5: this.staffing5,
            Dependability1: this.dependability1,
            Dependability2: this.dependability2,
            BehaviorPlan1: this.behaviorPlan1,
            // Program2: this.program2,
            // Program3: this.program3,
            // Program4: this.program4,
            Communication1: this.Communication1,
            Communication2: this.Communication2,
            Communication3: this.Communication3,
            Communication4: this.Communication4,
            Communication5: this.Communication5,
            Communication6: this.Communication6,
            Medical1: this.medical1,
            Medical2: this.medical2,
            // Medical3: this.medical3,
            Goals1: this.goals1,
            Goals2: this.goals2,
            // Goals3: this.goals3,
            // Goals4: this.goals4,
            // Goals5: this.goals5,
            HouseKeeping1: this.houseKeeping1,
            // Finances2: this.finances2,
            // Finances3: this.finances3,
            // Finances4: this.finances4,
            Personal1: this.personal1,
            Personal2: this.personal2,
            Personal3: this.personal3,
            Personal4: this.personal4,
            // Personal5: this.personal5,
            ScoreTotal: this.scoreTotal,
            Improvement: this.improvement,
            Successes: this.successes,
            StaffName: this.staffName,
            StaffDate: this.staffDate,
            ProgramDirector: this.programDirector,
            ProgramDate: this.programDate,
            StaffID: this.staffID,
        };

        axios.post(`${url}/areaManager`, req_body).then((res) => {
            // this.getDiagnoses();
            if (res.status == 400) {
            res.json().then(function(data) {
                this.text = data.msg;
            });
            }
            this.employeeName= "",
            this.employeeDate= "",
            this.individual1= 0,
            this.individual2= 0,
            this.individual3= 0,
            this.individual4= 0,
            this.individual5= 0,
            this.staffing1= 0,
            this.staffing2= 0,
            this.staffing3= 0,
            this.staffing4= 0,
            this.staffing5= 0,
            this.security1= 0,
            this.security2= 0,
            this.program1= 0,
            this.program2= 0,
            this.program3= 0,
            this.program4= 0,
            this.transportation1= 0,
            this.transportation2= 0,
            this.transportation3= 0,
            this.medical1= 0,
            this.medical2= 0,
            this.goals1= 0,
            this.goals2= 0,
            this.goals3= 0,
            this.goals4= 0,
            this.goals5= 0,
            this.finances1= 0,
            this.finances2= 0,
            this.finances3= 0,
            this.finances4= 0,
            this.personal1= 0,
            this.personal2= 0,
            this.personal3= 0,
            this.personal4= 0,
            this.personal5= 0,
            this.scoreTotal= 0,
            this.improvement= "",
            this.successes= "",
            this.staffName = "",
            this.staffDate = "".
            this.programDirector= "",
            this.programDate= "",
            this.msg = true;
            this.text = "The new diagnoses has been added successfully.";
        });
        this.close();
        },

    }
}
</script>